let buttons = null;
let intervalId = null;
let originalButtonStates = new Map();

//Função para desabilitar o botão e incluir texto "carregando..."
function loadingButtonFunction() {
  const clearButton = (button) => {
    const originalState = originalButtonStates.get(button);
    button.className = originalState.className;
    button.innerHTML = originalState.innerHTML;

    const loadingButton = document.querySelector('.loading-button');

    if (loadingButton) {
      loadingButton.parentNode.removeChild(loadingButton);
    }

    clearInterval(intervalId);
    intervalId = null;
  };

  buttons = document.querySelectorAll('.loading-cta, .checkout-button');

  buttons.forEach((button) => {
    originalButtonStates.set(button, {
      className: button.className,
      innerHTML: button.innerHTML
    });

    button.addEventListener('click', function(e) {
      if (intervalId) {
        clearInterval(intervalId);
        this.textContent = 'Carregando';
      }

      this.classList.add('disabled-cta');
      
      let loadingButton = document.querySelector('.loading-button');

      if (!loadingButton) {
        loadingButton = document.createElement('div');
        loadingButton.className = 'loading-button';
        this.parentNode.insertBefore(loadingButton, this.nextSibling);
      }

      this.textContent = 'Carregando';

      let i = 0;
      intervalId = setInterval(() => {
        i = (i + 1) % 5;
        this.textContent = 'Carregando' + '.'.repeat(i);
      }, 500);

      window.addEventListener('load', () => clearButton(this));
      window.addEventListener('popstate', () => clearButton(this));
    });
  });
}

document.addEventListener('DOMContentLoaded', loadingButtonFunction);

jQuery(document).ready(function($) {
  loadingButtonFunction();

  $(document.body).on('updated_wc_div', function() {
      loadingButtonFunction();
  });
});


//Removendo as classes da função "loadingButtonFunction" quando a pagina houver alguma ação diferente.
const clearButtonGlobal = () => {
  if (buttons) {
    buttons.forEach((button) => {
      const originalState = originalButtonStates.get(button);
      button.className = originalState.className;
      button.innerHTML = originalState.innerHTML;

      const loadingButton = document.querySelector('.loading-button');

      if (loadingButton) {
        loadingButton.parentNode.removeChild(loadingButton);
      }

      clearInterval(intervalId);
      intervalId = null;
    });
  }
};

window.onpageshow = function(event) {
  clearButtonGlobal();
};

window.addEventListener('pageshow', () => {
  clearButtonGlobal();
});

window.addEventListener('hashchange', () => {
  clearButtonGlobal();
});

window.addEventListener('popstate', () => {
  clearButtonGlobal();
});